import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-745b38c0")

_pushScopeId("data-v-745b38c0")
const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { class: "p-d-flex p-flex-column kn-flex functions-main-content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_KnFabButton = _resolveComponent("KnFabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_FunctionsCatalogFilterCards = _resolveComponent("FunctionsCatalogFilterCards")
  const _component_FunctionsCatalogDatatable = _resolveComponent("FunctionsCatalogDatatable")
  const _component_FunctionsCatalogDetail = _resolveComponent("FunctionsCatalogDetail")
  const _component_FunctionsCatalogPreviewDialog = _resolveComponent("FunctionsCatalogPreviewDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
      start: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('managers.functionsCatalog.title')), 1)
      ]),
      end: _withId(() => [
        (!_ctx.detailDialogVisible)
          ? (_openBlock(), _createBlock(_component_KnFabButton, {
              key: 0,
              icon: "fas fa-plus",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showForm(null)))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar",
            "data-test": "progress-bar"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_FunctionsCatalogFilterCards, {
        class: "p-m-3",
        propFilters: _ctx.filters,
        onSelected: _ctx.onSelectedFilter
      }, null, 8, ["propFilters", "onSelected"]),
      _createVNode(_component_FunctionsCatalogDatatable, {
        class: "p-m-3",
        user: _ctx.user,
        propLoading: _ctx.loading,
        items: _ctx.functions,
        onSelected: _ctx.showForm,
        onPreview: _ctx.onPreview,
        onDeleted: _ctx.deleteFunction
      }, null, 8, ["user", "propLoading", "items", "onSelected", "onPreview", "onDeleted"])
    ]),
    _createVNode("div", null, [
      _withDirectives(_createVNode(_component_FunctionsCatalogDetail, {
        visible: _ctx.detailDialogVisible,
        propFunction: _ctx.selectedFunction,
        functionTypes: _ctx.filters,
        onClose: _ctx.onDetailClose,
        onCreated: _ctx.onCreated
      }, null, 8, ["visible", "propFunction", "functionTypes", "onClose", "onCreated"]), [
        [_vShow, _ctx.detailDialogVisible]
      ]),
      _createVNode(_component_FunctionsCatalogPreviewDialog, {
        visible: _ctx.previewDialogVisible,
        propFunction: _ctx.selectedFunction,
        datasets: _ctx.datasets,
        onClose: _ctx.onPreviewClose
      }, null, 8, ["visible", "propFunction", "datasets", "onClose"])
    ])
  ]))
})